// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rE33","col":"styles_col__1lrdI"};